<!--
  - Copyright (c) 2017 Ytica.com a.s. - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited
  - Proprietary and confidential
  -
  -->

<template>
  <v-container fluid grid-list-sm pa-0 fill-height>
    <v-layout row wrap>
      <v-flex xs12 pt-0>
        <div v-if="iframe_url" class="content_iframe" :style="{ height: content_height+'px' }">
            <iframe @load="onResize" frameborder="0" :style="{ height: content_height+'px'}" id="main_content_iframe" scrolling="yes" :src="iframe_url"></iframe>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import console from '../logger.js'

export default {
  name: 'Iframe',
  props: ['url', 'send_account_id', 'childPath', 'permissions'],
  data () {
    return {
      content_height: 300
    }
  },
  computed: {
    initial_url: function () {
      if (this.url && this.childPath) {
        return this.url + this.childPath
      } else {
        return this.url
      }
    },
    iframe_url () {
      console.log(this.initial_url)
      let urlObj = new URL(this.initial_url)
      if (this.send_account_id) {
        urlObj.searchParams.append('account_id', this.$identity.user.account_id)
      }
      return urlObj.href
    }
  },
  watch: {
    permissions (newValue, oldValue) {
      this.checkPermission()
    }
  },
  created () {
    this.checkPermission()
  },
  mounted () {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  beforeDestroy () {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  methods: {
    checkPermission () {
      if (!this.permissions || !this.$identity.hasPermission(this.permissions, ':')) {
        console.error('permission denied for', this.permissions)
        this.$router.replace({name: 'dashboards'})
      }
    },
    onResize () {
      // console.log('resized!')
      // console.log(window.innerHeight, document.getElementById('headerWrapper').clientHeight)
      this.content_height = window.innerHeight - document.getElementById('headerWrapper').clientHeight
      if (this.$identity.talkdesk_user) {
        this.content_height -= 32
      }
      // console.log(this.content_height)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>
.content_iframe {
  height: 100%;
  overflow: hidden;

  @media screen and (max-width: 1200px) {
    -webkit-overflow-scrolling: touch !important;
    overflow-y: scroll !important;
  }
  iframe {
    width: 100%;
    height: 99.3%;
    min-height: 100%;

    top: 0;
    left: 0;
    overflow-x: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Iframe.vue